import { render, staticRenderFns } from "./t-list.vue?vue&type=template&id=3508b28e&"
import script from "./t-list.vue?vue&type=script&lang=js&"
export * from "./t-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports